import React, { useState, useEffect } from "react";
import Navbar from "../Components/Layout/Navbar";
import HeroSection from "./Partials/HeroSection";
import ContactSection from "./Partials/ContactSection";
import PortfolioCarousel from "./Partials/PortfolioCarousel";
import Footer from "../Components/Layout/Footer";
import FeaturedWork from "./Partials/FeaturedWork";
import { useLanguage } from "../Contexts/LanguageContext";
import { getImages, getPortfolioImages } from "../Constants/Index"; // Import the function

const Index = () => {
    const { language } = useLanguage(); // Get global language from context
    const [images, setImages] = useState(getImages(language)); // Initialize with default language images
    const [portfolioImages, setPortfolioImages] = useState(getPortfolioImages(language));

    // Re-fetch images when language changes
    useEffect(() => {
        setImages(getImages(language));
        setPortfolioImages(getPortfolioImages(language));
    }, [language]); // This runs every time language changes

    return (
        <div>
            <Navbar />
            <HeroSection />
            <FeaturedWork language={language} images={images} />
            <PortfolioCarousel language={language} images={portfolioImages} />
            <ContactSection />
            <Footer />
        </div>
    );
};

export default Index;
